// Thin composition layer - re-exports from focused sub-modules
import {
  prepareCreatePlacementPayload, applyTextCaseTransformation,
  assignPayloadValues, preparePayloadForPlacmentsUpdate,
  prepareCreatePackagePayload, createSelectedPlacementAsChildLineItems,
  assignParameterValueToChildPlacement, createPackageChildItemsPayload
} from './createPlacement-payload';

import {
  createPlacementOrPackage, updatePlacementOrPackage, updatePlacements
} from './createPlacement-api';

import {
  validateFormData, assignParameterValueToChildPlacementUpdatePayload,
  getPackageType, getProgrammaticType, createFormDataForPlanItPackage,
  convertObjectKeys, cleanAndConvertString,
  updatePdmsDataInPlacementTaxonomyFields, updatePdmsDataInParameterCodeTaxonomyFields
} from './createPlacement-utils';

// backward-compatible service object
export const CreatePlacementOrPackageService = {
  // payload builders
  prepareCreatePlacementPayload,
  applyTextCaseTransformation,
  assignPayloadValues,
  preparePayloadForPlacmentsUpdate,
  prepareCreatePackagePayload,
  createSelectedPlacementAsChildLineItems,
  assignParameterValueToChildPlacement,
  createPackageChildItemsPayload,

  // api
  createPlacementOrPackage,
  updatePlacementOrPackage,
  updatePlacements,

  // utils
  validateFormData,
  assignParameterValueToChildPlacementUpdatePayload,
  getPackageType,
  getProgrammaticType,
  createFormDataForPlanItPackage,
  convertObjectKeys,
  cleanAndConvertString,
  updatePdmsDataInPlacementTaxonomyFields,
  updatePdmsDataInParameterCodeTaxonomyFields,
};
